/* eslint-disable import/prefer-default-export */
export const COURSE_DATA = `
query($moduleId: Int, $type: String, $courseId: Int, $unitId: Int, $mode: String, $examType: String, $examMode: String, $count: Int, $levelCode: String, $projectCode: String, $action: String, $testId: Int, $overviewId: Int){
  englishCourseData(moduleId: $moduleId, type: $type, courseId: $courseId, unitId: $unitId, mode: $mode, examType: $examType, examMode: $examMode, count: $count, levelCode: $levelCode, projectCode: $projectCode, action: $action, testId: $testId, overviewId: $overviewId){
    id
    type
    status
    navigation
    title
    subtitle
    description
    isBacktrack
    message
    playTimes
    bookMode
    isScoring
    quizzes{
      id
      parentId
      code
      mode
      ... on EnglishCourseQuizQHLJ {
        image
        text
        explain
        isScoring
        fix {
          word
          tag
        }
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on EnglishCourseQuizDX {
        answer
        answerIndex
        question
        options
        parse {
          audio
          text
        }
        userAnswer
      }
      ... on EnglishCourseQuizBQWZ {
        article
        userAnswer
        extras
        parts {
          id
          answer
          parse {
            audio
            text
          }
        }
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizMED {
        duration
        items {
          id
          duration
          text
          explain
          audio
          image
        }
      }
      ... on EnglishCourseQuizKY {
        text
        audio
        beep
        image
        explain
      }
      ... on EnglishCourseQuizJXZH {
        question
        userAnswer
        answer
        extras
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizTYLJ {
        text
        userAnswer
        explain
        answer
        audio
        extras
      }
      ... on EnglishCourseQuizWK {
        video
        poster
        videoDone
        quizzes {
          question
          options
          answer
          type
          time
        }
      }
      ... on EnglishCourseQuizCHXZ {
        text
        explain
        audio
        options
        answer
        gameId
        userAnswer
        isScoring
      }
      ... on EnglishCourseQuizDCTX {
        text
        userAnswer
        explain
        audio
        gameId
        isScoring
      }
      ... on EnglishCourseQuizSK {
        text
        explain
        phonetic
        audio
        exampleSentence
        exampleExplain
        gameId
        isScoring
      }
      ... on EnglishCourseQuizHYDC {
        text
        explain
        audio
        gameId
        isScoring
        userAnswer
      }
      ... on EnglishCourseQuizDCPX {
        text
        explain
        fixs
        audio
        gameId
        isScoring
        userAnswer
      }
      ... on EnglishCourseQuizYDLJ {
        article
        userAnswer
        highlightWords
        parse {
          audio
          text
          imageList {
            name
            url
          }
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizWXTK {
        article
        userAnswer
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizTHXZ {
        article
        audio
        userAnswer
        playTimes
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizXCTK {
        article
        extras
        userAnswer
        parse {
          audio
          text
        }
        items {
          id
          answer
          parse {
            audio
            text
          }
        }
      }
    }
  }
}`;

export const EXAM_MODEL_LIST = `query ($courseId: Int, $unitId: Int) {
  englishExamModelList(courseId: $courseId, unitId: $unitId) {
    navigation
    title
    list {
      label
      value
      status
    }
  }
}`;

export const COURSE_RESULT = `
mutation ($id: Int, $courseId: Int, $unitId: Int, $moduleId: Int, $type: String, $mode: String, $quizzes: String!, $spend: String, $seconds: Int, $isBacktrack: Int, $levelCode: String) {
  englishCourseResult(id: $id, courseId: $courseId, unitId: $unitId, moduleId: $moduleId, type: $type, mode: $mode, quizzes: $quizzes, spend: $spend, seconds: $seconds, isBacktrack: $isBacktrack, levelCode: $levelCode) {
    examId
    beforeExamId
    score
    progress
    isContinue
    bookReview
    message
    name
    schoolName
    bookName
    unitName
    wordCount
    time
    star
    exp
    nextLevelInfo {
      itemType
      itemCode
      unitId
    }
  }
}`;

export const VERIFY_WRONG_WORD = `query ($courseId: Int) {
  verifyWrongWord(courseId: $courseId) {
    isHint
    count
  }
}`;

export const EXAM_ONLINE_MODEL_LIST = `query($type: String) {
  englishOnlineExamModelList(type: $type) {
    label
    value
  }
}`;

const QUIZZES_FRAGMENT = `
quizzes {
  id
  code
  mode
  ... on EnglishCourseQuizYDLJ {
    article
    highlightWords
    parse {
      audio
      text
      imageList {
        name
        url
      }
    }
    items {
      id
      text
      answer
      options
      wrongAnswer
      parse {
        audio
        text
      }
    }
  }
  ... on EnglishCourseQuizCHXZ {
    text
    explain
    audio
    options
    answer
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizDCTX {
    text
    explain
    audio
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizSK {
    text
    explain
    phonetic
    audio
    exampleSentence
    exampleExplain
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizHYDC {
    text
    explain
    audio
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizDCPX {
    text
    explain
    fixs
    audio
    gameId
    userAnswer
  }
}
`;

export const EXAM_DETAIL = `query($examId: Int, $type: String, $userId: String) {
  englishExamDetail(examId: $examId, type: $type, userId: $userId) {
    name
    courseName
    schoolName
    score
    wordCount
    time
    unitName
    qrcode
    ${QUIZZES_FRAGMENT}
  }
}`;

export const DIFF_EXAM_DETAIL = `
query(
  $beforeExamId: Int!
  $afterExamId: Int!
  $type: String
) {
  diffEnglishExamDetail(
    beforeExamId: $beforeExamId
    afterExamId: $afterExamId
    type: $type
  ) {
    navigation
    score
    ${QUIZZES_FRAGMENT}
  }
}`;

export const ENGLISH_SCORING = `
  mutation(
    $courseId: Int
    $unitId: Int
    $type: String!
    $quizzes: String!
  ) {
    englishScoring(
      courseId: $courseId
      unitId: $unitId
      type: $type
      quizzes: $quizzes
    )
  }
`;
